import { graphql } from 'GQL/gql';

const USER_SKILLS_CREATE = graphql(`
  mutation USER_SKILLS_CREATE(
    $record: [CreateOneUserSkillInput]!
    $policiesPreset: PoliciesPresetInput
  ) {
    userSkillCreateMany(record: $record) {
      __typename
      recordId
      record {
        ...userSkillFields
      }
    }
  }
`);

const USER_SKILL_UPDATE = graphql(`
  mutation USER_SKILL_UPDATE(
    $record: UpdateByIdUserSkillInput!
    $policiesPreset: PoliciesPresetInput
  ) {
    userSkillUpdateById(record: $record) {
      __typename
      recordId
      record {
        ...userSkillFields
      }
    }
  }
`);

const USER_SKILLS_UPDATE = graphql(`
  mutation USER_SKILLS_UPDATE(
    $records: [UpdateManyUserSkillInput]!
    $policiesPreset: PoliciesPresetInput
  ) {
    userSkillsUpdateMany(records: $records) {
      ...userSkillFields
    }
  }
`);

const USER_SKILL_DELETE = graphql(`
  mutation USER_SKILL_DELETE($skillId: ID!) {
    userSkillRemoveById(skillId: $skillId)
  }
`);

const USER_VALIDATION_SKILLS = graphql(`
  mutation USER_VALIDATE_SKILLS(
    $personValidateSkillIds: [ID!]!
    $policiesPreset: PoliciesPresetInput
  ) {
    userValidateSkillConfirmMany(personValidateSkillIds: $personValidateSkillIds) {
      ...userSkillFields
    }
  }
`);

const MANAGER_SUGGESTION_USER_SKILL = graphql(`
  mutation userValidateSkillSuggestMany(
    $records: [CreateUserValidateSkillSuggestionInput!]!
    $userId: ID!
  ) {
    userValidateSkillSuggestMany(records: $records, userId: $userId) {
      record {
        expertise
        suggestedBy {
          _id
          profile {
            name
          }
        }
        suggestedAction
      }
    }
  }
`);

const MANAGER_DELETE_SUGGESTION = graphql(`
  mutation userValidateSkillRemoveBySkillIdsByManager($skillIds: [ID!]!, $userId: ID!) {
    userValidateSkillRemoveBySkillIdsByManager(skillIds: $skillIds, userId: $userId)
  }
`);

export {
  MANAGER_DELETE_SUGGESTION,
  MANAGER_SUGGESTION_USER_SKILL,
  USER_SKILL_DELETE,
  USER_SKILL_UPDATE,
  USER_SKILLS_CREATE,
  USER_SKILLS_UPDATE,
  USER_VALIDATION_SKILLS,
};
